export const runOnSelected = (selector, func, parent = document) => {
  parent
    .querySelectorAll(selector)
    .forEach((element, index) => func(element, index, selector));
};
